import React, { useEffect, useState, useRef } from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Routes from 'containers/Routes';
import { Button } from 'reactstrap';
import {Link, useHistory} from 'react-router-dom';
import { connect } from 'react-redux';
import { refreshTokenAction, logout } from 'redux/modules/auth/action';
import moment from 'moment';
import momentTZ from 'moment-timezone';
import { loadState } from 'redux/localStorage';

const MainPage = (props) => {
    let history = useHistory();

    const [cookie, setCookie] = useState(true);
    const timerToClear = useRef(false);

    const UpdateToken = () => {
        let auth;
        if(loadState()) {
            auth = loadState().auth;
        } else {
            auth = props.auth;
        }
        if(auth.isAuthenticated) {
            const correctOffset = momentTZ.tz(momentTZ.tz.guess()).utcOffset();
            const finishDate = moment(auth.wsseToken.accessTokenExpiredAt);
            const startDate = moment().utcOffset(-correctOffset);
            const difference = moment.duration(finishDate.diff(startDate)).asMinutes();
            //console.log('Time difference: ', difference);
            if (difference <= 7 && difference > 0) {
                //console.log('Redux: ', props.auth.wsseToken.refreshToken);
                //console.log('LocalStorage: ', loadState().auth.wsseToken.refreshToken);
                props.refreshTokenAction({
                    _token: auth.wsseToken.refreshToken,
                });
            } else if (difference < 1) {
                props.logout();
                history.push('/');
            }
        } else {
            props.logout();
            history.push('/');
        }
    };

    useEffect(() => {
        let auth;
        //fix for incognito mode cuz store.subscribe do not triggers on first page load ???
        if(loadState()) {
            auth = loadState().auth;
        } else {
            auth = props.auth;
        }
        if (auth.isAuthenticated) {
            //console.log('timer start')
            timerToClear.current = setInterval(() => {
                UpdateToken();
            }, 30000);
            const correctOffset = momentTZ.tz(momentTZ.tz.guess()).utcOffset();
            const finishDate = moment(auth.wsseToken.accessTokenExpiredAt);
            const startDate = moment().utcOffset(-correctOffset);
            const difference = moment.duration(finishDate.diff(startDate)).asMinutes();
            if (difference < 1) {
                props.logout();
                history.push('/');
            }
            return () => {
                clearInterval(timerToClear.current);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.auth.wsseToken]);

    const closeCookie = () => {
        let theDate = new Date();
        let oneYearLater = new Date(theDate.getTime() + 31536000000);
        let expiryDate = oneYearLater.toGMTString();

        document.cookie = `user-agree=true;expires=${expiryDate}`;

        setCookie(false);
    };

    return (
        <div className="app sidebar-lg-show d-flex flex-column">
            {cookie && !document.cookie.includes('user-agree') && (
                <div className="cookies-modal">
                    <span style={{ fontSize: '15px' }}>
                        We use cookies to ensure that we give you the best experience on our website. 
                        If you continue to use this site we will assume that you are happy with it.
                    </span>
                    <div className="d-flex ml-2">
                        <Button size="sm" className="btn-square btn-info mr-2" onClick={closeCookie}>
                            OK
                        </Button>
                        <Link to="/privacy_policy">
                            <Button size="sm" className="btn-square" style={{ width: '260px' }}>
                                Read more in our Privacy Policy
                            </Button>
                        </Link>
                    </div>
                </div>
            )}
            <Header {...props} />
            <div className="main d-flex flex-column">
                <div className="h-100 d-flex flex-column">
                    <div className="flex-grow-1 d-flex">
                        <Routes />
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { refreshTokenAction, logout }
)(MainPage);
